// extracted by mini-css-extract-plugin
module.exports = {"o1yzqw59":"o1yzqw59","r1xf3ip9":"r1xf3ip9","c8bsm36":"c8bsm36","s1lircjl":"s1lircjl","sw5v5yo":"sw5v5yo"};